import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ShieldCheck, Save } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const RetentionCard = ({ token }) => {
  const [data, setData] = useState(null);
  const [years, setYears] = useState(6);
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    axios.get(`${API_URL}/api/compliance/retention`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => { setData(r.data); setYears(r.data.retention_years); }).catch(() => {});
  }, [token]);

  const save = async () => {
    try {
      const r = await axios.put(`${API_URL}/api/compliance/retention`, { retention_years: Number(years) }, { headers });
      setData(r.data);
      toast.success(`Durée de conservation : ${r.data.retention_years} ans`);
    } catch (err) { toast.error(err.response?.data?.detail || 'Erreur'); }
  };

  if (!data) return null;
  const options = [];
  for (let y = data.min_years; y <= data.max_years; y += 1) options.push(y);

  return (
    <div className="rounded-xl border border-slate-700/60 bg-slate-900/60 p-4 print:hidden" data-testid="retention-card">
      <p className="text-white font-semibold text-sm flex items-center gap-2"><ShieldCheck size={16} className="text-emerald-400" /> Conservation des documents</p>
      <div className="flex flex-wrap items-center gap-2 mt-3">
        <span className="text-xs text-slate-400">Inspections, mesures, bons et entretiens conservés</span>
        <select value={years} onChange={e => setYears(e.target.value)} disabled={!data.can_edit}
          className="bg-slate-800 border border-slate-700 rounded-lg px-2 py-1 text-sm text-white" data-testid="retention-years-select">
          {options.map(y => <option key={y} value={y}>{`${y} ans${y === data.default_years ? ' (recommandé)' : ''}`}</option>)}
        </select>
        {data.can_edit && Number(years) !== data.retention_years && (
          <button onClick={save} className="flex items-center gap-1 px-3 py-1 rounded-lg bg-amber-500 text-black text-xs font-semibold" data-testid="retention-save-btn">
            <Save size={12} /> Enregistrer
          </button>
        )}
      </div>
      <ul className="text-[11px] text-slate-500 mt-3 space-y-0.5 list-disc pl-4">
        <li>Minimum SAAQ : 2 dernières années d'utilisation + 12 mois après la vente du véhicule.</li>
        <li>6 ans couvre aussi Revenu Québec. Les factures d'atelier ne sont jamais supprimées automatiquement.</li>
        <li>Rondes de sécurité / inspections avant départ des chauffeurs : supprimées après 6 mois.</li>
        <li>Avis envoyé dans les notifications 30 jours avant toute suppression.</li>
      </ul>
      <p className={`text-xs mt-3 ${data.pending.total ? 'text-amber-400' : 'text-emerald-400'}`} data-testid="retention-pending">
        {data.pending.total
          ? `${data.pending.total} document(s) atteindront le délai dans les 30 prochains jours (datés avant le ${data.pending.cutoff}). Téléchargez le dossier pour les garder.`
          : 'Aucun document à supprimer dans les 30 prochains jours.'}
      </p>
    </div>
  );
};
